import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

// const firebaseConfig = {
//   apiKey: "AIzaSyBvWfzohHVok-OT604l-1c9cZ97fxycdsQ",
//   authDomain: "initials-labs.firebaseapp.com",
//   projectId: "initials-labs",
//   storageBucket: "initials-labs.firebasestorage.app",
//   messagingSenderId: "1093472763720",
//   appId: "1:1093472763720:web:67114eaaa10733094bfd7d",
//   measurementId: "G-53YRF7Z87M"
// };

const firebaseConfig = {
  apiKey: "AIzaSyBsxh91Z6H9FmiFVCXJTFLXjwc6_4vXq2k",
  authDomain: "sdhh-f3dc4.firebaseapp.com",
  databaseURL: "https://sdhh-f3dc4-default-rtdb.firebaseio.com",
  projectId: "sdhh-f3dc4",
  storageBucket: "sdhh-f3dc4.appspot.com",
  messagingSenderId: "311095208478",
  appId: "1:311095208478:web:b0d1629b1497e253d15c0f"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
